export default "__VITE_ASSET__BbZNDUDn__"